import { FigureSelectionArea } from 'features/fde'
import {
  GeckoComponentDataFrame,
  GeckoMeasurement,
  GeckoMeasurementUnit,
} from 'types'

export interface SelectedBins {
  minCorner: [number, number]
  maxCorner: [number, number]
}

export function toBaseUnit(measurement: GeckoMeasurement): number {
  return measurement.convertTo(GeckoMeasurementUnit.Millimeters).num
}

export function estimatedBinCount(
  selection: FigureSelectionArea,
  binning: GeckoComponentDataFrame['data']['binning']
): number {
  const xLen = toBaseUnit(selection.x.end) - toBaseUnit(selection.x.start)
  const yLen = toBaseUnit(selection.y.end) - toBaseUnit(selection.y.start)

  const binsWide = Math.ceil(xLen / toBaseUnit(binning.bin_size.width))
  const binsHigh = Math.ceil(yLen / toBaseUnit(binning.bin_size.height))

  return binsWide * binsHigh
}

export function measurementToBin(
  x: GeckoMeasurement,
  y: GeckoMeasurement,
  binning: GeckoComponentDataFrame['data']['binning'],
  geometry: GeckoComponentDataFrame['data']['geometry']
): [number, number] {
  const binWidth = toBaseUnit(binning.bin_size.width)
  const binHeight = toBaseUnit(binning.bin_size.height)

  const binX = Math.floor(
    Number(
      ((toBaseUnit(x) - toBaseUnit(geometry.x.start)) / binWidth).toPrecision(8)
    )
  )
  const binY = Math.floor(
    Number(
      ((toBaseUnit(y) - toBaseUnit(geometry.y.start)) / binHeight).toPrecision(
        8
      )
    )
  )
  return [binX, binY]
}

export function selectionToBins(
  figureSelectionArea: FigureSelectionArea,
  binning: GeckoComponentDataFrame['data']['binning'],
  geometry: GeckoComponentDataFrame['data']['geometry']
): SelectedBins {
  return {
    minCorner: measurementToBin(
      figureSelectionArea.x.min,
      figureSelectionArea.y.min,
      binning,
      geometry
    ),
    maxCorner: measurementToBin(
      figureSelectionArea.x.max,
      figureSelectionArea.y.max,
      binning,
      geometry
    ),
  }
}

export function extractBinSize(cdf: GeckoComponentDataFrame): [number, number] {
  return [
    cdf.data.binning.bin_size.width,
    cdf.data.binning.bin_size.height,
  ].map(
    (measurement) => measurement.convertTo(GeckoMeasurementUnit.Millimeters).num
  ) as [number, number]
}

export function binToMeasurement(
  binCoord: number,
  offset: number,
  binSize: number
) {
  return binCoord * binSize + offset + binSize / 2
}
